import React, { useCallback } from 'react';

import { getActionList } from 'api/hs/actions';
import { HSTableProps } from 'Common/Table/HSTable/hs-table.props';
import HSTableAndPaginationAndTableContextProvider from 'Common/Table/HSTable/HSTableAndPaginationAndTableContextProvider';

import DateDifferent from '../../../../utils/DateDifferent';
import { COLUMNS } from './columns';
import EditDialog from './EditDialog';
import ListTable from './ListTableData';
import Toolbar from './Toolbar';

export default function ActionList() {
  const fetchActionList = useCallback<HSTableProps<any>['fetcher']>((page, size, sorting, extra) => {
    return getActionList(
      page,
      size,
      sorting === false ? null : `${sorting.id as string}-${sorting.direction.toUpperCase()}`,
      extra.filters ?? {}
    );
  }, []);

  return (
    <>
      <HSTableAndPaginationAndTableContextProvider fetcher={fetchActionList} columns={COLUMNS}>
        <Toolbar />
        <ListTable />
        <EditDialog />
      </HSTableAndPaginationAndTableContextProvider>
    </>
  );
}
